import { Animated } from "react-animated-css";
import me from "../assets/imgs/me.jpg";
// import cv from 'https://drive.google.com/file/d/1ETO4mLK6YNU6DIiqxVY6R0fHKXFRgQlg/view?usp=sharing'

export default function Intro(props) {
  let delay = 1500;

  return (
    <div>
      <div id="intro">
        <div id="navbar">
          <div id="logo">
            <a href="#">Elswerky</a>
          </div>
        </div>
        <div className="port-content">
          <div id="port">
            <Animated
              animationIn="bounceInDown"
              animationInDuration={1000}
              animationInDelay={10}
            >
              <img
                src={me}
                onClick={() => props.setCountAdd(props.countAdd + 1)}
                alt="elswerky photo"
              />
            </Animated>
            <Animated
              animationIn="bounceInDown"
              animationInDuration={delay}
              animationInDelay={250}
              style={{ textAlign: "center" }}
            >
              <button>
                {/* <a href={cv} download='Ahmed Swerky.pdf'> */}
                <a
                  href="https://drive.google.com/file/d/1ETO4mLK6YNU6DIiqxVY6R0fHKXFRgQlg/view?usp=sharing"
                  download="Ahmed Swerky.pdf"
                >
                  {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-download"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg> */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                    fill="currentColor"
                  >
                    <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM432 256c0 79.5-64.5 144-144 144s-144-64.5-144-144s64.5-144 144-144s144 64.5 144 144zM288 192c0 35.3-28.7 64-64 64c-11.5 0-22.3-3-31.6-8.4c-.2 2.8-.4 5.5-.4 8.4c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-2.8 0-5.6 .1-8.4 .4c5.3 9.3 8.4 20.1 8.4 31.6z" />
                  </svg>
                  View C.V
                </a>
              </button>
            </Animated>
          </div>
          <div id="content">
            <div id="circles">
              <div id="infos">
                <Animated
                  animationIn="bounceInDown"
                  animationInDuration={delay}
                  animationInDelay={150}
                >
                  <h1>
                    Hi,
                    <br />
                    I'm Ahmed Swerky
                  </h1>
                </Animated>
                <Animated
                  animationIn="bounceInDown"
                  animationInDuration={delay}
                  animationInDelay={200}
                >
                  {/* <h2>A (3 years experience) Front-End Developer</h2> */}
                  <h2>
                    Passionate front-end developer with three years of hands-on
                    experience creating dynamic and responsive web applications.
                    Proficient in HTML, CSS, and JavaScript, I bring a touch of
                    UI and UX with the effeciency of the logic and performance.
                  </h2>
                </Animated>{" "}
              </div>
              <div id="skills">
                <Animated
                  animationIn="bounceInDown"
                  animationInDuration={delay}
                  animationInDelay={550}
                  className="skilld"
                >
                  React
                </Animated>
                <Animated
                  animationIn="bounceInDown"
                  animationInDuration={delay}
                  animationInDelay={550}
                  className="skilld"
                >
                  Redux
                </Animated>
                <Animated
                  animationIn="bounceInDown"
                  animationInDuration={delay}
                  animationInDelay={550}
                  className="skilld"
                >
                  Node.js
                </Animated>
                <Animated
                  animationIn="bounceInDown"
                  animationInDuration={delay}
                  animationInDelay={400}
                  className="skilld"
                >
                  JS
                </Animated>
                <Animated
                  animationIn="bounceInDown"
                  animationInDuration={delay}
                  animationInDelay={300}
                  className="skilld"
                >
                  HTML
                </Animated>
                <Animated
                  animationIn="bounceInDown"
                  animationInDuration={delay}
                  animationInDelay={350}
                  className="skilld"
                >
                  CSS
                </Animated>
                <br />
                <Animated
                  animationIn="bounceInDown"
                  animationInDuration={delay}
                  animationInDelay={550}
                  className="skilld"
                >
                  REST API
                </Animated>
                <Animated
                  animationIn="bounceInDown"
                  animationInDuration={delay}
                  animationInDelay={450}
                  className="skilld"
                >
                  PHP
                </Animated>
                <Animated
                  animationIn="bounceInDown"
                  animationInDuration={delay}
                  animationInDelay={500}
                  className="skilld"
                >
                  MYSQL
                </Animated>

                {/* <div class="skilld"></div>
							<div class="skilld"></div>
							<div class="skilld"></div>
							<div class="skilld"></div>
            <div class="skilld"></div> */}
              </div>

              <div id="skills_2">
                <Animated
                  animationIn="bounceInUp"
                  animationInDuration={delay}
                  animationInDelay={550}
                >
                  Firebase
                </Animated>
                <Animated
                  animationIn="bounceInUp"
                  animationInDuration={delay}
                  animationInDelay={550}
                >
                  MongoDB
                </Animated>
                <Animated
                  animationIn="bounceInUp"
                  animationInDuration={delay}
                  animationInDelay={550}
                >
                  GCP
                </Animated>
                <Animated
                  animationIn="bounceInUp"
                  animationInDuration={1000}
                  animationInDelay={550}
                >
                  BootStrap
                </Animated>
                <Animated
                  animationIn="bounceInUp"
                  animationInDuration={1000}
                  animationInDelay={550}
                >
                  GIT
                </Animated>
                <Animated
                  animationIn="bounceInUp"
                  animationInDuration={1000}
                  animationInDelay={550}
                >
                  Adobe XD
                </Animated>
                <Animated
                  animationIn="bounceInDown"
                  animationInDuration={delay}
                  animationInDelay={550}
                  className="skilld"
                >
                  Flutter
                </Animated>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
